import { IContactStatus } from "../Types/IContactStatus";
import { PlayerDataSingleton } from "./PlayerDataSingleton";
import { OnlineStatus } from "../Types/OnlineStatus";
import { TContactID } from "../Types/TContactID";
import { Conversations } from "../Data/Conversations";
import { IConversation } from "../Types/IConversation";
import { TFlagId } from "../Types/SharedTypes";

export let NarrativeSingleton: _NarrativeSingleton;

class _NarrativeSingleton {
    constructor() {
        if(NarrativeSingleton) {
            throw new Error("Only one instance allowed!");
        }
    }

    finishConversation(_conversation: IConversation): void {
        PlayerDataSingleton.setConversationSeen(_conversation.scriptId);
    }

    addFlag(_id: TFlagId): void {
        PlayerDataSingleton.addNarrativeFlag(_id);
    }

    hasFlag(_id: TFlagId): boolean {
        return PlayerDataSingleton.hasNarrativeFlag(_id);
    }

    getAllConversationsForContact(_contactId: TContactID): IConversation[] {
        const res: IConversation[] = [
            ...Conversations.filter((e) => e.participants.indexOf(_contactId) !== -1)
        ];

        if(res.length === 0) {
            console.warn("No conversations found for %s", _contactId);
        }

        return res;
    }

    getFirstValidConversationForContact(_contactId: TContactID): IConversation {
        const day = PlayerDataSingleton.getDay();
        return this.getAllConversationsForContact(_contactId)
            .find((e) => this.isWithinDay(day, e));
    }

    private isWithinDay(_day: number, _conv: IConversation): boolean {
        return _day >= _conv.dayRange[0] && _day < _conv.dayRange[1];
    }

    getContactState(): IContactStatus[] {
        const res: IContactStatus[] = [];

        const eligibleContacts = PlayerDataSingleton.getContacts();
        const day = PlayerDataSingleton.getDay();

        const conversationsBuffer: Record<TContactID, IConversation[]> = {};
        eligibleContacts.forEach((contactId) => {
            // if(!Conversations[contactId]) {
            //     console.warn(
            //         "Missing conversations data for contact ID %s", contactId
            //     );
            // }
            Conversations.filter((e) => e.participants.indexOf(contactId) !== -1)
                .forEach((e) => {
                    if(!conversationsBuffer[contactId]) {
                        conversationsBuffer[contactId] = [];
                    }
                    if(this.isWithinDay(day, e)) {
                        if(PlayerDataSingleton.hasSeenConversation(e.scriptId)) {
                            e.participants.forEach((e) => {
                                const contact = res.find((c) => c.id === e);
                                if(!contact) {
                                    res.push({
                                        id: e,
                                        status: OnlineStatus.Away
                                    });
                                } else {
                                    // check if there's any pending convos
                                    if(conversationsBuffer[e].length > 0) {
                                        contact.status = OnlineStatus.Online;
                                    } else {
                                        contact.status = OnlineStatus.Away;
                                    }
                                }
                            });
                        } else {
                            conversationsBuffer[contactId].push(e);
                            e.participants.forEach((e) => {
                                const contact = res.find((c) => c.id === e);
                                if(!contact) {
                                    res.push({
                                        id: e,
                                        status: OnlineStatus.Online
                                    });
                                } else {
                                    contact.status = OnlineStatus.Online;
                                }
                            });
                        }
                    } else {
                        e.participants.forEach((e) => {
                            const contact = res.find((c) => c.id === e);
                            if(!contact) {
                                res.push({
                                    id: e,
                                    status: OnlineStatus.Offline
                                });
                            } else {
                                contact.status = OnlineStatus.Offline;
                            }
                        });
                    }
                });
        });

        return res;
    }
}

NarrativeSingleton = new _NarrativeSingleton();